import { IPersonalDataObject } from '@vfit/shared/models';

export enum REGION {
  ITALIA = 'Italia',
  ITALIA_EN = 'Italy',
  FOREIGN_COUNTRY = 'Estero',
  FOREIGN_COUNTRY_EN = 'Foreign',
}

export enum GENDER {
  MALE = 'Maschio',
  MALE_EN = 'Male',
  FEMALE = 'Femmina',
  FEMALE_EN = 'Female',
}

export type IFiscalCodeInfo = {
  errorMessage: string;
  title: string;
  description: string;
  firstName: string;
  lastName: string;
  birthDate: string;
  gender: string;
  nationality: string;
  birthPlace: string;
  buttonLabel: string;
  birthNation: string;
};

export type IFiscalCodeData = {
  defaultData?: IPersonalDataObject;
  onSubmit: (data: IPersonalDataObject) => void;
  data?: IFiscalCodeInfo;
  cmsValidationConfig?: IRetrieveFiscalCodeValidation;
};

export interface IRetrieveFiscalCodeValidation {
  requiredField?: string;
  validFiscalCode?: string;
  validName?: string;
  validSurname?: string;
  surnameMinLen?: string;
  validDate?: string;
  nameMinLen?: string;
}
